import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['data_quality']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8014')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
setupInterceptors(appApisGTW);
var headers = {
  'Content-Type': 'application/json'
};
var CONTROLLER_NAME = '/data_quality';
var DOMAIN_VALIDATION_TYPE = '/validation_type';
export default {
  getProfilingValidationTypes: function getProfilingValidationTypes() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    tasks.lockScreen.lock();
    return appApisGTW.get("".concat(CONTROLLER_NAME).concat(DOMAIN_VALIDATION_TYPE, "/get_all"), {
      headers: headers
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  }
};